import { useTable } from '@kss/ui';

/**
 * Storefront order paths for the CURRENT table. The table lives in the session (set from a
 * scanned QR / `/t/:code` URL), so internal nav uses stable `/order*` routes — the table code
 * never appears (and can't be tampered with) in these URLs. `table` is the current code for display.
 */
export function useTablePaths() {
  const table = useTable();
  return {
    table,
    menu: '/order',
    track: '/order/track',
    bill: '/order/bill'
  };
}
